export default __webpack_public_path__ + "static/media/lokering.eb4f619d.png";